
<div class="amplify-container" *ngIf="_show">
  <div class="amplify-form-container" data-test="sign-in-section">
    <div class="amplify-form-body" data-test="sign-in-body-section">
      <div class="amplify-form-header" data-test="sign-in-header-section">
        {{ this.amplifyService.i18n().get('Sign in to your account') }}
      </div>
      <amplify-auth-username-field-core
        [usernameAttributes]="_usernameAttributes"
        (usernameFieldChanged)="onUsernameFieldChanged($event)"
      ></amplify-auth-username-field-core>
      <div class="amplify-form-row amplify-signin-password">
        <label class="amplify-input-label" for="passwordField">
          {{ this.amplifyService.i18n().get('Password *') }}
        </label>
        <input #passwordField
          (keyup)="setPassword(passwordField.value)"
          (keyup.enter)="onSignIn()"
          class="amplify-form-input"
          type="password"
          required
          placeholder="{{ this.amplifyService.i18n().get('Enter your password') }}"
          data-test="sign-in-password-input"
        />
        <span class="amplify-form-action" *ngIf="!shouldHide('ForgotPassword')">
          {{ this.amplifyService.i18n().get('Forgot Password?') }}
          <a class="amplify-form-link"
            (click)="onForgotPassword()"
            data-test="sign-in-forgot-password-link"
          >{{ this.amplifyService.i18n().get('Reset password') }}</a>
        </span>
      </div>
      <div class="amplify-form-actions">
        <div class="amplify-form-cell-right">
          <button class="amplify-form-button"
            (click)="onSignIn()"
            data-test="sign-in-sign-in-button"
          >{{ this.amplifyService.i18n().get('Sign In') }}</button>
        </div>
        <div class="amplify-form-cell-left" *ngIf="!shouldHide('SignUp')">
          <div class="amplify-form-signup">
            {{ this.amplifyService.i18n().get('No account?') }}
            <a
              class="amplify-form-link"
              (click)="onSignUp()"
              data-test="sign-in-create-account-link"
              >
              {{ this.amplifyService.i18n().get('Create account') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div
        class="amplify-alert-message"
        data-test="authenticator-error"
        >
          {{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
